import React, { useEffect, useState, useContext } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import { Card, CardHeader, Stack } from '@mui/material'
import MaterialButton from '../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom'
import MaterialTypography from '../../components/MaterialTypography'
import MaterialDataGrid from '../../components/MaterialDataGrid';
import axios from 'axios';
import BASEURL from "../Utils/Baseurl"
import {useUserDetails} from '../../context/auth'

function TableSalaryAdvance() {
    const navigate = useNavigate()
    const {setviewdisplay} = useUserDetails()
    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const [year, month, day] = dateStr.split("-");
        return `${day}-${month}-${year}`;
      };
      
    const handlAddAdvance =() => {
        navigate('/salary-advance/add-advance')
    }
    const [advanceList, setAdvanceList] = useState([]);
    const [pageState, setPageState] = useState({
            loading: false,
            error: false,
            message: "",
            state: 'init'
        })

    const salaryadvanceListTable = {
        columns: [
            {
                field: "firstName",
                headerName: "First Name",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true
            },
            {
                field: "lastName",
                headerName: "Last Name",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true
            },
            {
                field: "employeeId",
                headerName: "Employee ID",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true
            },
            {
                field: "amount",
                headerName: "Amount",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true
            },
            {
                field: "requestedOn",
                headerName: "Request Date",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true
            },
            {
                field: "paymentMode",
                headerName: "Payment Mode",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true
            },
            {
                field: "remainingBalance",
                headerName: "Pending Balance",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
                renderCell: (params) => `₹${Number(params.value || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`
            },
            {
                field: "emiStatus",
                headerName: "Status",
                flex: 1,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
                renderCell: (params) => {
                    const normalised = (params.value || "active").toLowerCase();
                    const styles = {
                        active:   { background: "#e3f2fd", color: "#1565c0", border: "1px solid #90caf9" },
                        pending:  { background: "#e3f2fd", color: "#1565c0", border: "1px solid #90caf9" },
                        shortfall:{ background: "#fff3e0", color: "#e65100", border: "1px solid #ffb74d" },
                        completed:{ background: "#e8f5e9", color: "#2e7d32", border: "1px solid #a5d6a7" },
                    };
                    const s = styles[normalised] || styles.active;
                    const label = normalised === "shortfall" ? "⚠ Shortfall"
                                : normalised === "pending"   ? "Active"
                                : normalised.charAt(0).toUpperCase() + normalised.slice(1);
                    return (
                        <span style={{ ...s, padding: "2px 10px", borderRadius: 12, fontSize: 12, fontWeight: 600 }}>
                            {label}
                        </span>
                    );
                }
            },
        ],
        row: advanceList.map(i => {
            return(
                {
                    id: i.id,
                    firstName: i.user.firstName,
                    lastName: i.user.lastName,
                    employeeId: i.employeeId,
                    amount: i.amount,
                    requestedOn: formatDate(i.requestedOn),
                    paymentMode: i.paymentMode,
                    remainingBalance: i.remainingBalance,
                    emiStatus: i.emiStatus,
                }
            )
        })
    }

    const onSalaryAdvanceListClick = (e) => {
        if(e?.id) {
            navigate(`/salary-advance/add-advance`, { state: { id: e?.id } });
        }
    };
    
    const fetchSalaryAdvances = async () => {       
            const query =
            `query allSalaryAdvances{
                allSalaryAdvances {
                    id
                    user{
                    id
                    firstName
                    lastName
                    }
                    employeeId
                    amount
                    requestedOn
                    paymentMode
                    remainingBalance
                    emiStatus
                }
            }`
        
        try {
            setPageState((prevState) => ({ ...prevState, loading: true }));

            const response = await axios.post(BASEURL, { query }, {
                headers: { 'Content-Type': 'application/json' }
            });

            if (response.data.errors) {
                throw new Error(response.data.errors[0].message);
            }

            const advanceListData = response.data.data.allSalaryAdvances || [];
            setAdvanceList(advanceListData);

            setPageState((prevState) => ({ ...prevState, loading: false, state: 'success' }));
        } catch (error) {
            console.error('Error fetching Salary Advances:', error);
            setPageState((prevState) => ({ 
                ...prevState, 
                loading: false, 
                error: true, 
                message: error.message 
            }));
        }
    }

    useEffect(() => {
        fetchSalaryAdvances();
    },[]);


  return (
    <DashboardLayout>
        <Card>
            <CardHeader title={(
                <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                    Salary Advance List
                            </MaterialTypography>
                        </Stack>
                
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon/>}
                    onClick={() => handlAddAdvance()}>
                        Salary Advance
                    </MaterialButton>
                </Stack>
            )}/>
            
            <MaterialDataGrid
                    rows={salaryadvanceListTable.row}
                    columns={salaryadvanceListTable.columns}
                    checkboxSelection={false}
                    isSelectable={false}
                    onRowClick={onSalaryAdvanceListClick}
                    localeText={{
                        noRowsLabel: (
                            <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <MaterialTypography variant="body2" fontWeight="medium" color="text">
                                    No Salary Advance Data found
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    You have not yet added any Salary Advance details. Click on the "Salary Advance " button to start adding Salary Advance.
                                </MaterialTypography>
                            </Stack>
                        )
                    }}
                />
        </Card>
    </DashboardLayout>
  )
}

export default TableSalaryAdvance